module.exports = __webpack_public_path__ + "img/detail.87e01130.png";